import React, { useState } from "react";
import styled from "styled-components";
import "office-ui-fabric-core/dist/css/fabric.css";
import TreeViewHeader from "./TreeViewHeader";
import RenderTreeView from "./RenderTreeView";
import { usePageHeadingsTree } from "use-page-headings-tree";

const TocHeadingId = "__TOC-Component-toc-heading";

const SidebarRoot = styled.div`
	position: relative;
	min-height: 100%;
	height: 100%;
	@media all and (-ms-high-contrast: none) {
		position: fixed;
		top: 230px;
	}

	h2 {
		font-size: 1em;
		vertical-align: middle;
	}

	h2 .page-name {
		font-size: 0.9em;
		color: #555;
	}

	.animate-width {
		transition: width 500ms ease-out;
	}

	.show {
		opacity: 1;
		transition: opacity 300ms ease;
		transition-delay: 150ms;
	}

	.hide {
		opacity: 0;
		pointer-events: none;
	}

	.nav-icon {
		margin: 0;
		font-size: 1.2em;
		font-weight: bold;
	}

	.toc-sidebar-container {
		position: absolute;
		top: 20px;
		left: 0;
		opacity: 1;
		min-height: 100%;
		height: 100%;
	}

	.toc-sidebar {
		position: sticky;
		top: 5px;
		opacity: 1;
		margin-bottom: 38px;
	}

	.tree-view-container {
		overflow: auto;
	}

	a {
		font-weight: 400 !important;
	}
`;

// eslint-disable-next-line react/display-name
const TOC = React.memo(
	({
		isVisible,
		pageName,
		collapsedWidth,
		expandedWidth,
		onToggling,
		headingNodes,
		shouldDefaultToExpand,
		location,
	}) => {
		const [headings, setHeadings] = useState([]);

		const sidebarWidth = isVisible ? expandedWidth : collapsedWidth;

		const updateToggle = val => {
			if (onToggling) onToggling(val);
		};

		const handleNodeClick = (node, e) => {
			updateToggle(window.innerWidth > 1199);
		};

		usePageHeadingsTree(headingNodes, setHeadings, shouldDefaultToExpand);

		return (
			<SidebarRoot
				style={{
					width: sidebarWidth,
				}}
			>
				<div className="toc-sidebar-container">
					<div
						className={`toc-sidebar bg-light shadow-sm rounded-right border-top border-bottom border-right animate-width${
							isVisible ? " pb-5" : ""
						}`}
						style={{
							width: sidebarWidth,
							height: isVisible ? "99vh" : null,
						}}
					>
						<TreeViewHeader
							isSidebarVisible={isVisible}
							setIsSidebarVisible={updateToggle}
							pageName={pageName}
							tocHeadingId={TocHeadingId}
						/>
						<div
							className={`bg-dark text-nowrap tree-view-container overflow-hidden${
								isVisible ? "" : " d-none"
							}`}
						>
							<div
								style={{
									minWidth: expandedWidth,
									overflow: "hidden",
								}}
							>
								<RenderTreeView
									data={headings}
									onNodeClick={handleNodeClick}
									treeLabelId={TocHeadingId}
								/>
							</div>
						</div>
					</div>
				</div>
			</SidebarRoot>
		);
	},
	(prev, next) =>
		prev.isVisible === next.isVisible &&
		prev.headingNodes.length === next.headingNodes.length &&
		prev.location.pathname === next.location.pathname &&
		prev.headingNodes.length > 0 &&
		prev.headingNodes[prev.headingNodes.length - 1].id ===
			next.headingNodes[next.headingNodes.length - 1].id
);

export default TOC;
